// extracted by css-extract-rspack-plugin
export default {"labelContainer":"labels-module__labelContainer__H8t0p","labelLink":"labels-module__labelLink__xj4nm"};